import { render } from "./SliceDetail.vue?vue&type=template&id=22622921&scoped=true&ts=true"
import script from "./SliceDetail.vue?vue&type=script&lang=ts"
export * from "./SliceDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22622921"]])

export default __exports__